import initialState from './initialState';
import actionType from './actionTypes';

const tradeExplorerReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_ALL_TRADES_SUCCESS: {
            return {
                ...state,
                trades: action.payload,
            };
        }
        case actionType.SET_ATTACHMENTS:
            return {
                ...state,
                attachments: action.payload,
            };
        case actionType.SET_TRADE_FORM_PROPS:
            return {
                ...state,
                tradeFormProps: action.payload,
            };
        case actionType.SET_CHILD_FORM_PROPS:
            return {
                ...state,
                childFormProps: action.payload,
            };
        default:
            return state;
    }
};

export default tradeExplorerReducer;
